/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_b5519ff6"]'><div :class='["toast-not-auto-close-demo"]'><cube-button @_click="clickToast">Toast - time 0s, not auto close</cube-button><cube-toast :time="(0)" txt="点击遮罩关闭" :mask="(true)" :maskClosable="(true)" ref="__mpx_ref_toast__"></cube-toast></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_b5519ff6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_b5519ff6"}
  /** script content **/
  require("./toast-not-auto-close.mpx.js?isComponent&outputPath=components%2Ftoast-not-auto-closeb5519ff6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./toast-not-auto-close.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftoast-not-auto-closeb5519ff6%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_b5519ff6"],
    ctorType: "component",
    outputPath: "components/toast-not-auto-closeb5519ff6/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>